import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import useNotification from 'hooks/useNotification';
import { useEffect, useRef, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import ApiKeyService from 'services/ApiKey.service';

const ApiKeyRegistrationModal = ({ show, onClose, refresh }) => {
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const initialState = {
    description: '',
    scopes: ['REPORTS']
  };
  const [body, setBody] = useState(initialState);
  const form = useRef(null);

  useEffect(() => {
    if (show) {
      setBody(initialState);
      setValidated(false);
    }
  }, [show]);

  const onSubmit = e => {
    e.preventDefault();

    if (form.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
    } else {
      createApiKey();
    }
  };

  const createApiKey = async () => {
    setIsLoading(true);
    const response = await ApiKeyService.create(body);
    if (response.id) {
      showSuccessNotification('Chave de API criada com sucesso');
      setBody({
        ...initialState
      });
      refresh();
      onClose();
    } else {
      showErrorNotification(response.userMessage);
    }
    setIsLoading(false);
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Nova Chave de API</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form validated={validated} onSubmit={onSubmit} ref={form}>
          <Form.Group className="mb-3">
            <Form.Label>
              Nome <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Insira um nome para identificar a chave"
              name="description"
              required
              value={body.description}
              onChange={e => setBody({ ...body, description: e.target.value })}
            />
            <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Insira um nome.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Escopos <span className="text-danger">*</span>
            </Form.Label>
            <Form.Check
              type="checkbox"
              label="Relatórios"
              value="REPORTS"
              checked={body.scopes.includes('REPORTS')}
              onChange={e =>
                setBody({
                  ...body,
                  scopes: e.target.checked
                    ? [...body.scopes, e.target.value]
                    : body.scopes.filter(scope => scope !== e.target.value)
                })
              }
            />
            <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Selecione pelo menos um escopo.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Flex} justifyContent="end">
            <Button variant="falcon-default" onClick={onClose} className="me-2">
              Cancelar
            </Button>
            <Button
              variant="primary"
              type="submit"
              onClick={onSubmit}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faSave} className="me-2" />
              {isLoading ? 'Salvando...' : 'Salvar'}
            </Button>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ApiKeyRegistrationModal;
